/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "banklin": {
        "nested": {
          "external": {
            "nested": {
              "ExternalSystem": {
                "values": {
                  "SQUARE_CASH_PAYMENT": 1,
                  "SQUARE_CASH_TRANSFER": 2,
                  "BANKSY_TRANSFER": 3,
                  "DASH_CARD": 4,
                  "CORE_PRO_ACH": 5,
                  "SHAZAM_CARD": 6,
                  "MARQETA_CARD": 7,
                  "SQUARE_CASH_CLAWBACK": 8,
                  "GREEN_DOT_ACH": 9,
                  "CARD_FULFILLMENT": 10,
                  "CARD_MAILING": 11,
                  "PITNEY_BOWES_CARD_MAILING": 12,
                  "BITCOIN_BLOCKCHAIN": 13,
                  "TRADEBLOCK": 14,
                  "SQUARE_CASH_TRADING": 15,
                  "THIRD_PARTY_TRADE": 16,
                  "MARQETA_BUSINESS_CARD": 17,
                  "DRIVEWEALTH": 18,
                  "INVEST_CORE": 19,
                  "MARQETA_ACH": 20,
                  "LEDGER_INTERNAL": 21,
                  "LOANSTAR": 22,
                  "SQUARE_CASH_REFUND": 23,
                  "SQUARE_CASH_ADMIN": 24,
                  "MOBILE_CHECK_DEPOSIT": 25,
                  "MITEK_CHECK_DEPOSIT": 26,
                  "BTC_NETWORK": 27,
                  "RISKARBITER_ACH": 28,
                  "INVEST_CRYPTO": 29,
                  "VDBS": 30,
                  "PAY_WITH_CASH": 31,
                  "INSTANT_PAY": 32,
                  "MODERN_TREASURY_WIRE": 33,
                  "VISA_CARD": 34,
                  "RISKARBITER_WIRE": 35,
                  "CRYPTO_SPARKY": 36,
                  "VISA_DPS_CARD": 37,
                  "NETWORK_OF_NETWORKS_GLOBAL_X": 38,
                  "DISPUTRON": 39,
                  "CASH_LIMITS": 40,
                  "CASH_ME_OUTSIDE": 41,
                  "CASH_BARB": 42,
                  "ENSENTA_CHECK_DEPOSIT": 43,
                  "SQUARE_BANKING_OPS": 44,
                  "OVERDRAFT": 45,
                  "CASH_DDA_ACH": 46,
                  "WELLS_FARGO_WIRE": 47,
                  "CASH_FOR_BUSINESS": 48,
                  "PIGGYBANK": 49,
                  "BILL_PAY_PAYMENTUS": 50,
                  "CIVIL_PROCESSOR": 51,
                  "ISTL": 52,
                  "ORDERLY_AFTERPAY": 53,
                  "BLOCK_STABLE": 54,
                  "SALVAGER": 55,
                  "TIMECARDS": 56,
                  "MARQETA_BUSINESS_CREDIT_CARD": 57,
                  "CROW": 58,
                  "BHN_BARCODE": 59,
                  "BHN_SWIPE": 60
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.banklin?.nested?.external?.nested?.ExternalSystem) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ExternalSystem @ squareup/banklin/external/external_system.proto at 7:1
 */
export const ExternalSystem = $root.lookupEnum('squareup.banklin.external.ExternalSystem').values;